<div fxFlex fxLayout="column" fxLayoutGap="1rem">
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{ 'drivers.drivers' | translate }}</span>
      <button mat-raised-button *ngxPermissionsOnly="['WRITE_DRIVERS']" color="primary" (click)="editDriver()">
        <mat-icon>add</mat-icon>
        {{ 'drivers.actions.create' | translate }}
      </button>
    </mat-toolbar-row>
  </mat-toolbar>


  <mat-card appearance="outlined" fxFlex="grow" fxLayout="column">
    <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onChangeTab($event)">
      <mat-tab [label]="'user.enabled' | translate"></mat-tab>
      <mat-tab [label]="'user.disabled' | translate"></mat-tab>
    </mat-tab-group>

    <table mat-table matSort [dataSource]="dataSource" class="main-content clickable-items-table" #driversTable>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>{{ 'user.firstName' | translate }}</th>
        <td mat-cell *matCellDef="let driver">{{ driver.firstName }}</td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>{{ 'user.lastName' | translate }}</th>
        <td mat-cell *matCellDef="let driver">{{ driver.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="department">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'departments.department' | translate }}</th>
        <td mat-cell *matCellDef="let driver">
          @if (driver.department) {
            <span class="department-color" [style.background-color]="driver.department.color"></span>
            {{ driver.department.name }}
          } @else {
            <span class="department-missing">&mdash;</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="abbreviation">
        <th mat-header-cell *matHeaderCellDef>{{ 'user.abbreviation' | translate }}</th>
        <td mat-cell *matCellDef="let driver">{{ driver.abbreviation }}</td>
      </ng-container>

      <ng-container matColumnDef="licenseClass">
        <th mat-header-cell *matHeaderCellDef>{{ 'vehicles.licenseClass' | translate }}</th>
        <td mat-cell *matCellDef="let driver">{{ driver.licenseClass | licenseClass | async }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{'core.actions' | translate}}</th>
        <td mat-cell *matCellDef="let driver" (click)="$event.stopPropagation()" class="actions-column">
          <mat-menu #driverActions>
            <button mat-menu-item (click)="editDriver(driver['@id'])">{{ 'drivers.actions.edit' | translate }}</button>
            @if (!driver.enabled) {
              <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deleteDriver(driver['@id'])">{{ 'drivers.actions.delete' | translate }}</button>
            }
            @if (driver.enabled) {
              <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deactivateDriver(driver)">{{ 'drivers.actions.deactivate' | translate }}</button>
            }
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="driverActions">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let driver; columns: tableColumns"
        [routerLink]="['/drivers', driver | objectId]"
        [class]="'linked-row'"
      ></tr>
    </table>
    @if (driversTable.dataSource.length == 0 ) {
      <app-no-result-message></app-no-result-message>
    }
  </mat-card>

  @if (actionPending$ | async) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
